
import Shimmer from "../ui/shimmer";

export const ClassCardLoading = () => (
  <div className="glass-card p-5 relative overflow-hidden">
    {/* Status badge skeleton */}
    <div className="absolute top-4 right-4">
      <Shimmer className="h-5 w-16 rounded-full" />
    </div>
    
    {/* Header with icon */}
    <div className="flex items-start gap-4 mb-4">
      <Shimmer className="w-12 h-12 rounded-xl shrink-0" />
      <div className="flex-1">
        <Shimmer className="h-5 w-3/4 mb-2" />
        <Shimmer className="h-4 w-1/2" />
      </div>
    </div>
    
    {/* Description */}
    <Shimmer className="h-4 w-full mb-2" />
    <Shimmer className="h-4 w-2/3 mb-4" />
    
    {/* Stats chips */}
    <div className="flex gap-2 mb-4">
      <Shimmer className="h-7 w-24 rounded-full" />
      <Shimmer className="h-7 w-20 rounded-full" />
      <Shimmer className="h-7 w-16 rounded-full" />
    </div>
    
    {/* Button */}
    <Shimmer className="h-9 w-full rounded-lg" />
  </div>
);

export const ClassesListLoading = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-7xl mx-auto mt-6">
    {[1, 2, 3, 4, 5, 6].map((i) => (
      <ClassCardLoading key={i} />
    ))}
  </div>
);

export const LoadingState = () => (
  <div className="min-h-screen bg-gradient-to-b from-primary/10 via-background to-background transition-colors duration-300">
    <div className="container mx-auto px-4 py-8">
      <div className="space-y-8 pt-8">
        {/* Header skeleton */}
        <div className="flex flex-col items-center gap-3">
          <Shimmer className="w-16 h-16 rounded-2xl" />
          <Shimmer className="h-10 w-64" />
          <Shimmer className="h-4 w-48" />
        </div>
        
        {/* Toggle group skeleton */}
        <div className="flex justify-center">
          <Shimmer className="h-12 w-80 rounded-2xl" />
        </div>
        
        {/* Search skeleton */}
        <div className="max-w-md mx-auto">
          <Shimmer className="h-12 w-full rounded-2xl" />
        </div>
        
        <ClassesListLoading />
      </div>
    </div>
  </div>
);
